import RatingSelectorWithRef from './RatingSelector';

export default RatingSelectorWithRef;
